import { useContext } from "react";
import { OrganisationContext } from "../context/OrganisationContext";
import { AvailableIntegrations } from "@attelas/shared";
import { useDynamicsSettings } from "./useDynamicsSettings";

export function useIsConnected() {
  const { organisation } = useContext(OrganisationContext);
  const appIntegrations = organisation?.integrations?.appIntegrations ?? [];
  const isConnectingDynamicsOnly =
    appIntegrations.length === 1 && appIntegrations[0].name === AvailableIntegrations.Dynamics;
  const { settings } = useDynamicsSettings(isConnectingDynamicsOnly);
  const selectedDynamicsCompanies = settings?.companies ?? [];
  return isConnectingDynamicsOnly ? selectedDynamicsCompanies.length > 0 : appIntegrations.length > 0;
}
